// need to decide the animation settings

// this animation is used for a single component
// when it is viewed it will be animated
"use client"


import { getItemVariants } from "@/app/utils/variants/itemVariants";
import { motion } from "framer-motion";

type Props = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  delay?: number;
  inView?: boolean;
}


export function AnimatedItem ({ children, className, style, delay = 0, inView = true }: Props) {
  const variants = getItemVariants(delay);

  return (
    <motion.div
      className={className}
      style={style}
      variants={variants}
      initial="hidden"
      whileInView={inView ? "visible" : undefined}
      viewport={{ once: true, amount: 0.2 }}
      animate={!inView ? "visible" : undefined}
    >
      {children}
    </motion.div>
  );
};